module.exports = __webpack_public_path__ + "img/hr-level3addon_idle.54ecd548.png";